export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2C1.5 1.44772 1.94772 1 2.5 1H13.1667C13.719 1 14.1667 1.44772 14.1667 2V6.33333H18.5C19.0523 6.33333 19.5 6.78105 19.5 7.33333V18C19.5 18.5523 19.0523 19 18.5 19H7.83333C7.28105 19 6.83333 18.5523 6.83333 18V13.6667L2.5 13.6667C2.23478 13.6667 1.98043 13.5613 1.79289 13.3738C1.60536 13.1862 1.5 12.9319 1.5 12.6667V2ZM6.83333 11.6667V7.33333C6.83333 6.78105 7.28105 6.33333 7.83333 6.33333H12.1667V3H3.5V11.6667L6.83333 11.6667ZM8.83333 8.33333V17H17.5V8.33333H8.83333Z" />
  `,
  title: 'Copy Icon',
  viewBox: '0 0 21 20',
};
